export default "__VITE_ASSET__Bmadq4oK__"